var wildTest = function wildTest(wildcard, value) {
  var re = new RegExp("^".concat(wildcard.replace(/\*/g, '.*').replace(/\?/g, '.'), "$"), 'i');
  return re.test(value);
};

export var isMatch = function isMatch(value, patterns) {
  return patterns.some(function (pattern) {
    return wildTest(pattern, value);
  });
};
export default isMatch;